<template>
  <div class="route-header__container" >
    <div class="route-header__helper" id="file" method="POST">
      <input type="hidden" id="payload" name="payload">
      <h3>{{getResource('BasketOptionsHeader')}}</h3>
        <p>{{getResource('BasketOptionsSubheader')}}</p>
        <button class="image-button tick-green" @click="selectAll" :disabled="basketSize == 0">{{getResource('SelectAll')}}</button>
        <button class="image-button mail-green" @click="emailSelected" :disabled="basketSelected == 0">{{getResource('EmailSelected')}}</button>
        <button class="image-button download-green" @click="downloadSelected" :disabled="basketSelected == 0">{{getResource('DownloadSelected')}}</button>
        <button class="image-button trash-green" @click="deleteSelected" :disabled="basketSelected == 0">{{getResource('DeleteSelected')}}</button>
    </div>
    <div class="route-header__info">
      <div class="route-header__icon icon-basket-white"></div>
      <h1>{{getResource('Basket')}}</h1>
        <p>{{getResource('BasketSubheader')}}</p>
    </div>
  </div>
</template>

<script>
import { getResource } from "../vuex/helpers";
import { selectAll, emailSelected, downloadSelected, deleteSelected } from "../views/basket/BasketActions";

export default {
  vuex: {
    getters: {
      basketSize: state => state.basketSize,
      basketSelected: state => state.basketSelected
    },
    actions: { getResource, selectAll, emailSelected, downloadSelected, deleteSelected }
  }
};
</script>


// WEBPACK FOOTER //
// RouteHeaderBasket.vue?13b6174e